/************************************************************
 Surgery Namespace
 ************************************************************/

window.surgeryNS = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Print requisition
        if(actionId == 23){
            var url = "/surgery/requisition_sheet?requisition_id="+action.task_id+"&patient_id="+row.patient_id;

            Hades.showDocument(url);
            surgeryNS._callback(true, surgeryNS._action, surgeryNS._row);

        }
        // Print patient consent
        else if(actionId == 26){
            var url = "/surgery/patient_consent?requisition_id="+action.task_id+"&patient_id="+row.patient_id;

            Hades.showDocument(url);
            surgeryNS._callback(true, surgeryNS._action, surgeryNS._row);

        }
        // Print Surgical Report
        else if(actionId == 97){
            var url = "/surgery/patient_surgical_report?requisition_id="+action.task_id+"&patient_id="+row.patient_id;

            Hades.showDocument(url);
            surgeryNS._callback(true, surgeryNS._action, surgeryNS._row);
        }
        // Print patient proposal consent
        else if(actionId == 116){
            var url = "/surgery/surgery_proposal_consent?requisition_id="+action.task_id+"&patient_id="+row.patient_id;

            Hades.showDocument(url);
            surgeryNS._callback(true, surgeryNS._action, surgeryNS._row);

        }
        // Cancel Requisition
        else if (actionId == 3) {
            surgeryNS.openReason(surgeryNS.cancelReasonModalHandler);
        }
        // Other actions
        else {
            surgeryNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(surgeryNS._action, surgeryNS._callback, surgeryNS._row);
    },
    // Open Reason
    openReason:function (callback) {
        debug.log('IN :2848');
        var params = {
            task_id:surgeryNS._action.task_id,
            wf_id:surgeryNS._action.wf_id,
            wf_status_id:surgeryNS._action.to_state_id,
            wf_action_id:surgeryNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                surgeryNS._callback(false, surgeryNS._action, surgeryNS._row);
            });
    },
    // Cancel Requisition
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:surgeryNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:surgeryNS._row.wf_id,
            wf_status_id:surgeryNS._row.wf_status_id,
            wf_action_id:data.actionId};

        $.post('/surgery/cancel_requisition', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    surgeryNS._callback(false, surgeryNS._action, surgeryNS._row);
                } else {
                    surgeryNS._callback(true, surgeryNS._action, surgeryNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                surgeryNS._callback(false, surgeryNS._action, surgeryNS._row);
            });
    },

    searchSurgicalActModal: function (callback, params) {
        Hades.showLoading();
        $.get('/surgery/search_ordem_medicos_classification_modal', {
            search:$('#medical_search_surgery').val(), width:$(window).width(), height:$(window).height(),
            financial_institution_id: $("#financial_institution option:selected").val()
        }, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data});

                $('#ordem-medicos-search-modal-ct').bind('itemSelected', function(evt, data){
                    callback(evt, data, params);
                });

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    }
};